import useLogout from '@vangst/services/oogst/viewer/useLogout'
import Routes from '@vangst/services/routes'
import { MdErrorOutline } from 'react-icons/md'
import ClickyExplore from '../../components/navigation/ClickyExplore'

export default function CourseNoAccess({
  sessionRedirect,
}: {
  sessionRedirect?: string
}) {
  const redirectTo = Routes.SIGN_UP
  const logout = useLogout(redirectTo, sessionRedirect)
  const signOut = () => logout.mutate({})
  return (
    <>
      <div className="flex flex-row ">
        <MdErrorOutline className="pb-6 text-orange" size="4rem" />

        <span className="mb-4 ml-2 text-md text-red">
          Courses require a Member Account. You’re logged in as a Company.
        </span>
      </div>
      <div className="mx-4 mb-6 border-b" />

      <ClickyExplore as="text-icon" className="w-full" onClick={signOut}>
        Sign Out & Create a Member Account
      </ClickyExplore>
    </>
  )
}
